var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 3.52734C23.3513 3.52734 29.3327 9.50868 29.3327 16.8607C29.3327 24.2127 23.3513 30.194 15.9993 30.194C8.64735 30.194 2.66602 24.2127 2.66602 16.8607C2.66602 9.50868 8.64735 3.52734 15.9993 3.52734ZM15.9993 5.52734C9.75002 5.52734 4.66602 10.6113 4.66602 16.8607C4.66602 23.11 9.75002 28.194 15.9993 28.194C22.2487 28.194 27.3327 23.11 27.3327 16.8607C27.3327 10.6113 22.2487 5.52734 15.9993 5.52734ZM16.0045 20.5885C16.7419 20.5885 17.3379 21.1845 17.3379 21.9219C17.3379 22.6592 16.7419 23.2552 16.0045 23.2552C15.2672 23.2552 14.6645 22.6592 14.6645 21.9219C14.6645 21.1845 15.2552 20.5885 15.9912 20.5885H16.0045ZM15.9915 10.7993C16.5435 10.7993 16.9915 11.2473 16.9915 11.7993V17.6913C16.9915 18.2433 16.5435 18.6913 15.9915 18.6913C15.4395 18.6913 14.9915 18.2433 14.9915 17.6913V11.7993C14.9915 11.2473 15.4395 10.7993 15.9915 10.7993Z",
    fill: "#9142C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.c293bb69f8a3450a354cb39c07287dfe.svg";
export { ForwardRef as ReactComponent };